import { createReducer } from '@reduxjs/toolkit';
import { MessagePool } from 'store/findProvider/types';
import { switchAccountSuccess } from 'store/account/actions';
import * as actions from '../actions';

export interface MessageComposeState {
  to: null | MessagePool;
  isSending: boolean;
}

export const messageComposeInitialState: MessageComposeState = {
  to: null,
  isSending: false
};

const messageComposeReducer = createReducer(messageComposeInitialState, {
  [actions.MESSAGE_COMPOSE_POOL_SELECTED]: (state, action) => {
    state.to = action.payload;
  },
  [actions.MESSAGE_COMPOSE_CLEAR_PROVIDER_SELECTED]: state => {
    state.to = null;
  },
  [actions.MESSAGE_COMPOSE_CANCEL]: state => {
    state.to = null;
  },
  [actions.MESSAGE_COMPOSE_SEND]: state => {
    state.isSending = true;
  },
  [actions.MESSAGE_COMPOSE_SEND_SUCCESS]: state => {
    state.isSending = false;
    state.to = null;
  },
  [actions.MESSAGE_COMPOSE_SEND_FAIL]: state => {
    state.isSending = false;
  },
  [switchAccountSuccess.type]: () => messageComposeInitialState
});

export default messageComposeReducer;
